import { ModuleWithProviders, NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { GlobalSearchComponent } from './global-search.component';
import { GlobalSearchService } from './global-search.service';

@NgModule({
    imports: [LsqCommonModule.forChild()],
    declarations: [GlobalSearchComponent],
    exports: [GlobalSearchComponent]
})
export class GlobalSearchModule {
    public static forRoot(): ModuleWithProviders<GlobalSearchModule> {
        return {
            ngModule: GlobalSearchModule,
            providers: [GlobalSearchService]
        };
    }

    public static forChild(): ModuleWithProviders<GlobalSearchModule> {
        return {
            ngModule: GlobalSearchModule
        };
    }
}
